// extracted by mini-css-extract-plugin
export default {"achievement-section":"ThroughYears_achievement-section__2c929","achievement-list":"ThroughYears_achievement-list__oVEQR"};